import { render, staticRenderFns } from "./index.vue?vue&type=template&id=03b3f33a"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/AI合规前端-测试/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03b3f33a')) {
      api.createRecord('03b3f33a', component.options)
    } else {
      api.reload('03b3f33a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=03b3f33a", function () {
      api.rerender('03b3f33a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/error-page/404/index.vue"
export default component.exports